import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import * as Colors from 'material-ui/styles/colors';
import {HoverMixin} from '../../../../../shared/helpers/mixins';
import reactMixin from 'react-mixin';

@reactMixin.decorate(HoverMixin)
export default class SimpleSelectableBox extends Component {
  state = {};
  render() {
    const {children, borderType} = this.props;
    const {hovered} = this.state;
    const style = _.clone(this.props.style);
    const {color, selected} = this.props;
    const inside = borderType === 'inside';
    let borderColor;
    if (!selected) {
      if (hovered) {
        borderColor = Colors.grey400;
      } else {
        borderColor = 'transparent';
      }
    } else if (selected) {
      borderColor = color;
    }

    const rootElementStyle = {transition: 'border-color 150ms ease-in-out', borderStyle: 'solid', borderWidth: 4, borderColor, ...style, position: 'relative', top: -4, left: -4};
    if (inside) {
      rootElementStyle.top = 0;
      rootElementStyle.left = 0;
      rootElementStyle.borderWidth = 0;
    }
    return (
      <div
        onMouseEnter = {this.onMouseEnter.bind(this)}
        onMouseLeave = {this.onMouseLeave.bind(this)}
        style={rootElementStyle}
      >
        {children}
        {
          inside &&
            <div
              style={{position: 'absolute', width: '100%', height: '100%', top: 0, left: 0, transition: 'border-color 150ms ease-in-out', borderStyle: 'solid', borderWidth: 4, borderColor, pointerEvents: 'none', boxSizing: 'border-box'}}
            />
        }
      </div>
    );
  }
}

SimpleSelectableBox.propTypes = {
  color: PropTypes.string,
  borderType: PropTypes.oneOf(['inside', 'outside']).isRequired,
  zDepth: PropTypes.number.isRequired,
  selectable: PropTypes.bool.isRequired,
};


SimpleSelectableBox.defaultProps = {
  color: Colors.lightGreen600,
  borderType: 'outside',
  selectable: true,
  zDepth: 2
};